import { render, staticRenderFns } from "./TransportationPrice.vue?vue&type=template&id=83f3972c&scoped=true&"
import script from "./TransportationPrice.vue?vue&type=script&lang=js&"
export * from "./TransportationPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f3972c",
  null
  
)

export default component.exports